module.exports = __webpack_public_path__ + "static/media/aaii.c24d4be1.jpg";